<template>
    <div class="search-widget-container shadow bg-white mb-5">
        <h4 class="search-widget-section-title">{{ $t("browse_by") }}</h4>
        <b-form-group class="search-type-radios">
            <b-form-radio v-model="type" name="search-type" value="all">{{
                $t("all_resources")
            }}</b-form-radio>
            <b-form-radio
                v-model="type"
                name="search-type"
                value="collections"
                >{{ $t("collections") }}</b-form-radio
            >
            <b-form-radio v-model="type" name="search-type" value="products">{{
                $t("products")
            }}</b-form-radio>
            <b-form-radio v-model="type" name="search-type" value="variants">{{
                $t("variants")
            }}</b-form-radio>
        </b-form-group>
        <hr />
        <div class="d-flex justify-content-between">
            <h4 class="search-widget-section-title">{{ $t("search") }}</h4>
            <div>
                <b-button
                    size="sm"
                    variant="secondary"
                    class="btn-round" 
                    @click="clearFilters"
                >
                    <font-awesome-icon :icon="['fas', 'rotate-left']" />
                    {{ $t("clear_filters") }}
                </b-button>
            </div>
        </div>

        <b-form-group class="search-widget-text-search">
            <template v-slot:prepend>
                <b-input-group-text>
                    <font-awesome-icon icon="search"></font-awesome-icon>
                </b-input-group-text>
            </template>
            <b-form-input
                type="search"
                :placeholder="$t('search')"
                v-model="query"
            ></b-form-input>
        </b-form-group>

        <b-form-group v-if="clients.length > 1" label="Client">
            <b-form-select v-model="client" @change="collection = null">
                <b-form-select-option :value="null">
                    {{ $t("all_clients") }}
                </b-form-select-option>

                <b-form-select-option
                    v-for="client in clients"
                    :key="client.id"
                    :value="client.id"
                >
                    {{ client.name }}
                </b-form-select-option>
            </b-form-select>
        </b-form-group>

        <b-form-group label="Collection">
            <b-form-select
                v-model="collection"
                :disabled="!client || collections.length === 0"
            >
                <b-form-select-option :value="null" v-if="!client">
                    {{ $t("select_client_first") }}
                </b-form-select-option>

                <b-form-select-option :value="null" v-else>
                    {{ $t("all_collections") }}
                </b-form-select-option>

                <b-form-select-option
                    v-for="collection in collections"
                    :key="collection.id"
                    :value="collection.id"
                >
                    {{ collection.name }}
                </b-form-select-option>
            </b-form-select>
        </b-form-group>

        <div class="filters-variants" v-if="type === 'variants'">
            <template v-for="attribute in attributes">
                <label class="text-capitalize" :key="`label-${attribute.id}`">{{
                    attribute.name
                }}</label>
                <multiselect
                    :key="attribute.id"
                    class="mb-3"
                    v-model="selectedAttributes[attribute.id]"
                    :options="attribute.options"
                    :multiple="true"
                    placeholder="Select at least one"
                    label="label"
                    track-by="id"
                ></multiselect>
            </template>
        </div>

    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { createHelpers } from "vuex-map-fields";
import axios from "axios";

// `fooModule` is the name of the Vuex module.
const { mapFields } = createHelpers({
  getterType: "smartVaultSearch/getField",
  mutationType: "smartVaultSearch/updateField"
});

export default {
  name: "SearchProduct",
  components: {
    Multiselect
  },
  data() {
    return {
      positionTop: 0,
      clients: [],
      collections: [],
      attributes: [],
      selectedAttributes: {}
    };
  },
  computed: {
    ...mapFields([
      "filters.query",
      "filters.type",
      "filters.client",
      "filters.collection"
    ])
  },
  watch: {
    client(n, o) {
      this.collections = [];
      if (n) {
        this.getCollectionsForClient();
      }
    },
    selectedAttributes: {
      handler(n, o) {
        let attributes = [];
        for (const attr in n) {
          if (!n[attr].length) {
            continue;
          }
          // @todo this is not pretty, we can create an axios serializer later
          attributes.push(n[attr].map(a => a.id).join(","));
        }
        this.$store.commit("smartVaultSearch/setAttributes", attributes);
      },
      deep: true
    }
  },
  mounted() {
    this.getClients().then(this.getCollectionsForClient);
    this.getAttributes();
  },
  methods: {
    getClients() {
      return axios.get("/api/clients").then(r => {
        this.clients = r.data.data;
        this.$store.commit("smartVaultSearch/setClients", r.data.data);
      });
    },
    getCollectionsForClient() {
      if (this.clients.length === 1) {
        this.client = this.clients[0].id;
      }

      if (!this.client) {
        return;
      }

      let client = this.clients.find(c => c.id === this.client);
      axios.get(`/api/clients/${client.id}/collections`).then(r => {
        this.collections = r.data.data;
      });
    },
    getAttributes() {
      axios.get("/api/product-attributes").then(r => {
        this.attributes = r.data.data;
      });
    },
    clearFilters() {
      this.$store.commit("smartVaultSearch/clearFilters");
      this.selectedAttributes = {};
    }
  }
};
</script>

<style scoped>
</style>
